import { ZodNullable, ZodOptional, type ZodTypeAny } from "zod";

export function unwrap(schema: ZodTypeAny): ZodTypeAny {
	if (schema instanceof ZodOptional || schema instanceof ZodNullable) {
		return schema.unwrap();
	}
	return schema;
}
